import {AnyAction} from "redux";
import {START_DRAGGING, STOP_DRAGGING} from "./action";


/**
 * start dragging
 */
export function startDragging() : AnyAction
{
    return {type: START_DRAGGING, payload: {}};
}

/**
 * stop dragging
 */
export function stopDragging() : AnyAction
{
    return {type: STOP_DRAGGING, payload: {}};
}


// WEBPACK FOOTER //
// ./src/ts/store/actions/interaction.ts